// import React, { useEffect, useState } from "react";
// import {
//     Table,
//     Button,
//     Modal,
//     Card,
//     Form,
//     Spinner,
//     Row,
//     Col,
//     InputGroup,
// } from "react-bootstrap";
// import { IconBrandVisa, IconCreditCard } from "@tabler/icons-react";
// import usePostRequest from "../../../hooks/usePostRequest";
// import { API_ENDPOINTS } from "../../../constant/_constant";
// import moment from "moment";
// import { toast } from "react-toastify";
// import { useSelector } from "react-redux";
// import ComanConfirmationModal from "../../../components/ComanConfirmationModal";
// import OtpVerifyPopup from "../../customer/OtpVerifyPopup";
// import CustomerCardEdit from "../../customer/CustomerCardEdit";
// import OtpVerficationPopup from "./OtpVerificationPopup";
// import OtpVerficationViewDetail from "./OtpVerificationViewDetail";

// function CardManagement({ show, onClose, emailId, orderId, transactionId, paymentAmount, onCardAdded, onOtpVerified }) {
//     // ── View state ──────────────────────────────────────────────────────────────
//     const [cardDetails, setCardDetails] = useState([]);
//     const [getCard, setGetCard] = useState(false);
//     const [addCard, setAddCard] = useState(false);

//     // ── Payment OTP state ────────────────────────────────────────────────────────
//     const [showOtpPopup, setShowOtpPopup] = useState(false);
//     const [paymentData, setPaymentData] = useState(null);

//     // ── Edit card OTP state ──────────────────────────────────────────────────────
//     const [showEditOtpPopup, setShowEditOtpPopup] = useState(false);
//     const [showCardDetails, setShowCardDetails] = useState(false);
//     const [verifiedCardData, setVerifiedCardData] = useState(null);
//     const [isModalOpen, setIsModalOpen] = useState({
//         show: false,
//         action: null,
//         message: "",
//     });

//     // ── Get Card form state ──────────────────────────────────────────────────────
//     const [getCardDetails, setGetCardDetails] = useState({ email: "" });
//     const [getCardErrors, setGetCardErrors] = useState({ email: "" });

//     // ── Add Card form state ──────────────────────────────────────────────────────
//     const [addCardData, setAddCardData] = useState({
//         cardHolderName: "",
//         cardNumber: "",
//         expiry: "",
//         cvc: "",
//         address: "",
//     });
//     const [addCardErrors, setAddCardErrors] = useState({
//         cardHolderName: "",
//         cardNumber: "",
//         expiry: "",
//         cvc: "",
//         address: "",
//     });

//     // ── API hooks ────────────────────────────────────────────────────────────────
//     const { postData: fetchCards } = usePostRequest(API_ENDPOINTS.GET_CUSTOMER_CARD);
//     const { postData: sendPaymentOtp } = usePostRequest(API_ENDPOINTS.PAYMENT_OTP);
//     const { isLoading: isLoadingGetCard, postData: postGetCard } = usePostRequest(API_ENDPOINTS.VERIFY_CUSTOMER_EMAIL);
//     const { isLoading: isLoadingAddCard, postData: postAddCard } = usePostRequest(API_ENDPOINTS.CREATE_CARD_INFO);
//     const { postData: VerifyCustomerOtp, data: Verified } = usePostRequest(API_ENDPOINTS.SEND_OTP_CARDS);

//     const user = useSelector((state) => state.auth.user);
//     const canEditCards = user?.permissions?.manage_cards?.includes("write");

//     // ── Fetch cards on open ──────────────────────────────────────────────────────
//     useEffect(() => {
//         if (show) {
//             fetchCards(
//                 { email: emailId, other_id: orderId },
//                 (res) => setCardDetails(res?.data || []),
//                 (err) => toast.error(err?.message || "No valid card details found. Please add card details first.")
//             );
//             setGetCardDetails({ email: emailId || "" });
//         } else {
//             setCardDetails([]);
//         }
//     }, [show]);

//     const refreshCards = () => {
//         fetchCards(
//             { email: emailId, other_id: orderId },
//             (res) => setCardDetails(res?.data || []),
//             (err) => toast.error(err?.message || "Failed to refresh card details.")
//         );
//     };

//     // ── Validation helpers ───────────────────────────────────────────────────────
//     const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
//     const validateCardHolderName = (value) => /^[A-Za-z\s]+$/.test(value);
//     const validateCardNumber = (value) => /^[0-9]{15,16}$/.test(value);
//     const validateExpiry = (value) => /^(0[1-9]|1[0-2])\/\d{2}$/.test(value);
//     const validateCVC = (value) => /^\d{3}$/.test(value);

//     // ── Payment OTP handlers ─────────────────────────────────────────────────────
//     const handleOtp = (cardInfo) => {
//         setPaymentData(cardInfo);
//         sendPaymentOtp(
//             { id: cardInfo?.id, type: "order_payment" },
//             (res) => {
//                 toast.success(res?.message || "OTP sent successfully");
//                 setShowOtpPopup(true);
//                 onClose();
//             },
//             (err) => toast.error(err?.message || "Failed to initiate payment OTP")
//         );
//     };

//     const handleOtpVerified = (response) => {
//         if (onOtpVerified) onOtpVerified(response);
//     };

//     // ── Edit card OTP handlers ───────────────────────────────────────────────────
//     const openEditModal = (id) => {
//         const handleSendOtp = () => {
//             VerifyCustomerOtp({ id }, onSuccessVerify, onErrorVerify);
//             setIsModalOpen((prev) => ({ ...prev, show: false }));
//             onClose();
//         };

//         setIsModalOpen({
//             show: true,
//             action: "success",
//             message: "Are you sure you want to view/edit customer's card details? An OTP will be sent for verification if you proceed.",
//             onConfirm: handleSendOtp,
//             title: "Edit Customer Card Details",
//             icon: <IconCreditCard />,
//             type: "info",
//         });
//     };

//     const onSuccessVerify = (res) => {
//         toast.success(res?.message);
//         setShowEditOtpPopup(true);
//     };

//     const onErrorVerify = (err) => {
//         toast.error(err?.message || "Failed to send OTP");
//     };

//     const handleOtpVerifiedEdit = (verifiedResponse) => {
//         setVerifiedCardData(verifiedResponse);
//         setShowEditOtpPopup(false);
//         setShowCardDetails(true);
//     };

//     // ── Get Card handlers ────────────────────────────────────────────────────────
//     const handleGetCardChange = (e) => {
//         const { name, value } = e.target;
//         let error = "";
//         if (value.trim() === "") {
//             error = `${name} is required`;
//         } else if (name === "email" && !validateEmail(value)) {
//             error = "Invalid email address";
//         }
//         setGetCardDetails((prev) => ({ ...prev, [name]: value }));
//         setGetCardErrors((prev) => ({ ...prev, [name]: error }));
//     };

//     const handleGetCardSubmit = (e) => {
//         e.preventDefault();
//         if (getCardDetails.email.trim() === "" || getCardErrors.email !== "") {
//             toast.error("Please correct the email before submitting");
//             return;
//         }
//         postGetCard(
//             { other_id: orderId, email: getCardDetails.email },
//             (res) => {
//                 toast.success(res?.message || "Card link sent successfully");
//                 refreshCards();
//                 if (onCardAdded) onCardAdded();
//                 resetForms();
//             },
//             (err) => toast.error(err?.message || "Failed to generate link for card")
//         );
//     };

//     // ── Add Card handlers ────────────────────────────────────────────────────────
//     const handleAddCardChange = (e) => {
//         const { name, value } = e.target;
//         let validationError = "";
//         let formattedValue = value.replace(/\D/g, "");

//         if (value.trim() === "") validationError = `${name} is required`;

//         if (name === "cardNumber") {
//             if (formattedValue.length > 16) formattedValue = formattedValue.slice(0, 16);
//             formattedValue = formattedValue.replace(/(.{4})(?=.)/g, "$1 ");
//             if (!validateCardNumber(formattedValue.replace(/\D/g, "")))
//                 validationError = "Card number must be 15 or 16 digits";
//         }

//         if (name === "expiry") {
//             if (formattedValue.length >= 3)
//                 formattedValue = formattedValue.slice(0, 2) + "/" + formattedValue.slice(2, 4);
//             if (!validateExpiry(formattedValue))
//                 validationError = "Expiry must be in MM/YY format";
//         }

//         if (name === "cvc") {
//             formattedValue = formattedValue.slice(0, 3);
//             if (formattedValue && !validateCVC(formattedValue))
//                 validationError = "CVC must be 3 digits";
//         }

//         if (name === "address") {
//             formattedValue = value;
//             validationError = "";
//         }

//         if (name === "cardHolderName") {
//             formattedValue = value;
//             if (!validateCardHolderName(value))
//                 validationError = "Cardholder name can only contain letters";
//         }

//         setAddCardData((prev) => ({ ...prev, [name]: formattedValue }));
//         setAddCardErrors((prev) => ({ ...prev, [name]: validationError }));
//     };

//     const handleAddCardSubmit = (e) => {
//         e.preventDefault();
//         const formIsValid =
//             Object.values(addCardErrors).every((err) => err === "") &&
//             addCardData.cardHolderName.trim() !== "" &&
//             addCardData.cardNumber.trim() !== "" &&
//             addCardData.expiry.trim() !== "";

//         if (!formIsValid) {
//             toast.error("Please fix all errors before submitting");
//             return;
//         }

//         postAddCard(
//             {
//                 auto_id: orderId,
//                 info_number: addCardData.cardNumber.replace(/\s+/g, ""),
//                 info_expiry: addCardData.expiry,
//                 info_name: addCardData.cardHolderName,
//                 cvc_code: addCardData.cvc,
//                 address: addCardData.address,
//                 type: "order",
//             },
//             (res) => {
//                 toast.success(res?.message || "Card added successfully");
//                 refreshCards();
//                 if (onCardAdded) onCardAdded();
//                 resetForms();
//             },
//             (err) => toast.error(err?.message || "Failed to add card")
//         );
//     };

//     // ── Reset / cancel ───────────────────────────────────────────────────────────
//     const resetForms = () => {
//         setGetCard(false);
//         setAddCard(false);
//         setGetCardDetails({ email: emailId || "" });
//         setGetCardErrors({ email: "" });
//         setAddCardData({ cardHolderName: "", cardNumber: "", expiry: "", cvc: "", address: "" });
//         setAddCardErrors({ cardHolderName: "", cardNumber: "", expiry: "", cvc: "", address: "" });
//     };

//     const handleClose = () => {
//         resetForms();
//         onClose();
//     };

//     // ── Render ───────────────────────────────────────────────────────────────────
//     return (
//         <>
//             {/* Edit Card - after OTP verified */}
//             {showCardDetails && (
//                 <CustomerCardEdit
//                     show={showCardDetails}
//                     onClose={() => setShowCardDetails(false)}
//                     formData={verifiedCardData}
//                 />
//             )}

//             {/* Edit confirmation modal */}
//             <ComanConfirmationModal
//                 show={isModalOpen.show}
//                 onHide={() => setIsModalOpen((prev) => ({ ...prev, show: false }))}
//                 title={isModalOpen.title}
//                 message={isModalOpen.message}
//                 onConfirm={isModalOpen.onConfirm}
//                 icon={isModalOpen.icon}
//                 type={isModalOpen.type}
//             />

//             {/* Edit OTP verification popup */}
//             {showEditOtpPopup && (
//                 <OtpVerifyPopup
//                     show={showEditOtpPopup}
//                     onClose={() => setShowEditOtpPopup(false)}
//                     formData={Verified}
//                     onVerified={handleOtpVerifiedEdit}
//                 />
//             )}

//             {/* Payment OTP verification popup */}
//             {showOtpPopup && (
//                 <OtpVerficationViewDetail
//                     show={showOtpPopup}
//                     onClose={() => setShowOtpPopup(false)}
//                     formData={paymentData}
//                     paymentAmountSales={paymentAmount}
//                     opportunityId={orderId}
//                     onVerified={(response) => {
//                         handleOtpVerified(response);
//                         setShowOtpPopup(false);
//                     }}
//                 />
//             )}

//             <Modal show={show} onHide={handleClose} size="xl">
//                 <Modal.Header className="gap-2 justify-content-between pe-5" closeButton>
//                     <div className="d-flex align-items-center gap-2">
//                         <span className="avatar bg-indigo-lt rounded-circle">
//                             <IconCreditCard />
//                         </span>
//                         <Modal.Title>Card Details</Modal.Title>
//                     </div>
//                     <div className="d-flex gap-2">
//                         <span
//                             className="add_new_card bg-indigo"
//                             style={{ cursor: "pointer" }}
//                             onClick={() => { setAddCard(!addCard); setGetCard(false); }}
//                         >
//                             {addCard ? "Hide" : "Add Card"}
//                         </span>
//                         <span
//                             className="add_new_card bg-indigo"
//                             style={{ cursor: "pointer" }}
//                             onClick={() => { setGetCard(!getCard); setAddCard(false); }}
//                         >
//                             {getCard ? "Hide" : "Get Card"}
//                         </span>
//                     </div>
//                 </Modal.Header>

//                 <Modal.Body>
//                     {/* ── Card Listing Table ─────────────────────────────────────────── */}
//                     <div className="table-responsive mail_wrapper p-0 border-0 mb-3 box-shadow-none">
//                         <Table className="table-bordered card-table">
//                             <thead>
//                                 <tr>
//                                     <th>CARDHOLDER NAME</th>
//                                     <th>CARD NUMBER</th>
//                                     <th>CARD EXPIRY</th>
//                                     <th>INVOICE NUMBER</th>
//                                     <th>CREATED DATE</th>
//                                     <th>ACTIONS</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {cardDetails.length === 0 ? (
//                                     <tr>
//                                         <td colSpan="6" className="text-center">
//                                             No card details found.
//                                         </td>
//                                     </tr>
//                                 ) : (
//                                     cardDetails.map((card) => (
//                                         <React.Fragment key={card.id}>
//                                             <tr>
//                                                 <td>{card.info_name}</td>
//                                                 <td>{"**** **** **** " + card.info_number}</td>
//                                                 <td>{card.info_expiry}</td>
//                                                 <td>{card.invoice_number || "N/A"}</td>
//                                                 <td>{moment(card.created_at).format("MM/DD/YYYY")}</td>
//                                                 <td className="d-flex gap-2">
//                                                     {!transactionId && (
//                                                         <Button
//                                                             className="w-auto"
//                                                             style={{ minWidth: "auto" }}
//                                                             onClick={() => handleOtp(card)}
//                                                         >
//                                                             Pay
//                                                         </Button>
//                                                     )}
//                                                     <Button
//                                                         className="w-auto"
//                                                         style={{ minWidth: "auto" }}
//                                                         onClick={() => openEditModal(card?.id)}
//                                                         disabled={!canEditCards}
//                                                     >
//                                                         View/Edit
//                                                     </Button>
//                                                 </td>
//                                             </tr>
//                                             <tr key={`note-${card.id}`}>
//                                                 <td colSpan="6" className="text-end">
//                                                     Notes: {card.note || "N/A"}
//                                                 </td>
//                                             </tr>
//                                         </React.Fragment>
//                                     ))
//                                 )}
//                             </tbody>
//                         </Table>
//                     </div>

//                     {/* ── Get Card Section ───────────────────────────────────────────── */}
//                     {getCard && (
//                         <Card className="add_credit_card mb-3 mt-3">
//                             <Card.Header className="card_header">GET NEW CARD</Card.Header>
//                             <Card.Body>
//                                 <Form onSubmit={handleGetCardSubmit}>
//                                     <Form.Group className="mb-3">
//                                         <Form.Label className="required">EMAIL</Form.Label>
//                                         <Form.Control
//                                             type="email"
//                                             name="email"
//                                             value={getCardDetails.email}
//                                             onChange={handleGetCardChange}
//                                             placeholder="Enter your email address"
//                                         />
//                                         {getCardErrors.email && (
//                                             <div className="text-danger">{getCardErrors.email}</div>
//                                         )}
//                                     </Form.Group>
//                                     <div className="d-flex justify-content-center gap-2">
//                                         <Button
//                                             type="submit"
//                                             variant="primary"
//                                             disabled={
//                                                 isLoadingGetCard ||
//                                                 getCardDetails.email.trim() === "" ||
//                                                 !!getCardErrors.email
//                                             }
//                                         >
//                                             {isLoadingGetCard ? (
//                                                 <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
//                                             ) : (
//                                                 "Get Card"
//                                             )}
//                                         </Button>
//                                         <Button type="button" variant="outline-secondary" onClick={resetForms}>
//                                             Cancel
//                                         </Button>
//                                     </div>
//                                 </Form>
//                             </Card.Body>
//                         </Card>
//                     )}

//                     {/* ── Add Card Section ───────────────────────────────────────────── */}
//                     {addCard && (
//                         <Card className="add_credit_card mb-3 mt-3">
//                             <Card.Header className="card_header">ADD NEW CARD</Card.Header>
//                             <Card.Body>
//                                 <Form onSubmit={handleAddCardSubmit}>
//                                     <Row>
//                                         <Col md={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label className="required">CARDHOLDER NAME</Form.Label>
//                                                 <InputGroup>
//                                                     <Form.Control
//                                                         name="cardHolderName"
//                                                         value={addCardData.cardHolderName}
//                                                         onChange={handleAddCardChange}
//                                                         placeholder="Enter Cardholder Name"
//                                                     />
//                                                 </InputGroup>
//                                                 {addCardErrors.cardHolderName && (
//                                                     <div className="text-danger">{addCardErrors.cardHolderName}</div>
//                                                 )}
//                                             </Form.Group>
//                                         </Col>
//                                         <Col md={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label className="required">CARD NUMBER</Form.Label>
//                                                 <InputGroup>
//                                                     <InputGroup.Text>
//                                                         <IconBrandVisa stroke={1} />
//                                                     </InputGroup.Text>
//                                                     <Form.Control
//                                                         name="cardNumber"
//                                                         value={addCardData.cardNumber}
//                                                         onChange={handleAddCardChange}
//                                                         type="text"
//                                                         placeholder="**** **** **** ****"
//                                                     />
//                                                 </InputGroup>
//                                                 {addCardErrors.cardNumber && (
//                                                     <div className="text-danger">{addCardErrors.cardNumber}</div>
//                                                 )}
//                                             </Form.Group>
//                                         </Col>
//                                         <Col md={4}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label className="required">EXPIRY</Form.Label>
//                                                 <InputGroup>
//                                                     <Form.Control
//                                                         name="expiry"
//                                                         value={addCardData.expiry}
//                                                         onChange={handleAddCardChange}
//                                                         type="text"
//                                                         placeholder="MM/YY"
//                                                         maxLength={5}
//                                                     />
//                                                 </InputGroup>
//                                                 {addCardErrors.expiry && (
//                                                     <div className="text-danger">{addCardErrors.expiry}</div>
//                                                 )}
//                                             </Form.Group>
//                                         </Col>
//                                         <Col md={4}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>CVC CODE</Form.Label>
//                                                 <InputGroup>
//                                                     <Form.Control
//                                                         name="cvc"
//                                                         value={addCardData.cvc}
//                                                         onChange={handleAddCardChange}
//                                                         type="password"
//                                                         maxLength={3}
//                                                         placeholder="123"
//                                                     />
//                                                 </InputGroup>
//                                                 {addCardErrors.cvc && (
//                                                     <div className="text-danger">{addCardErrors.cvc}</div>
//                                                 )}
//                                             </Form.Group>
//                                         </Col>
//                                         <Col md={12}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>ADDRESS</Form.Label>
//                                                 <InputGroup>
//                                                     <Form.Control
//                                                         name="address"
//                                                         value={addCardData.address}
//                                                         onChange={handleAddCardChange}
//                                                         placeholder="Enter Address"
//                                                     />
//                                                 </InputGroup>
//                                             </Form.Group>
//                                         </Col>
//                                     </Row>
//                                     <div className="d-flex justify-content-center gap-2">
//                                         <Button
//                                             type="submit"
//                                             variant="warning"
//                                             disabled={
//                                                 isLoadingAddCard ||
//                                                 Object.values(addCardErrors).some((err) => err !== "") ||
//                                                 addCardData.cardHolderName.trim() === "" ||
//                                                 addCardData.cardNumber.trim() === "" ||
//                                                 addCardData.expiry.trim() === ""
//                                             }
//                                         >
//                                             {isLoadingAddCard ? (
//                                                 <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
//                                             ) : (
//                                                 "Submit"
//                                             )}
//                                         </Button>
//                                         <Button type="button" variant="outline-secondary" onClick={resetForms}>
//                                             Cancel
//                                         </Button>
//                                     </div>
//                                 </Form>
//                             </Card.Body>
//                         </Card>
//                     )}
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// }

// export default CardManagement;

import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Card,
  Form,
  Spinner,
  Row,
  Col,
  InputGroup,
} from "react-bootstrap";
import {
  IconBrandVisa,
  IconCreditCard,
  IconCurrencyDollar,
} from "@tabler/icons-react";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import moment from "moment";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ComanConfirmationModal from "../../../components/ComanConfirmationModal";
import OtpVerifyPopup from "../../customer/OtpVerifyPopup";
import CustomerCardEdit from "../../customer/CustomerCardEdit";
import OtpVerficationPopup from "./OtpVerificationPopup";
import OtpVerficationViewDetail from "./OtpVerificationViewDetail";
import { usePostHog } from "@posthog/react";

function CardManagement({
  show,
  onClose,
  emailId,
  orderId,
  transactionId,
  paymentAmount,
  onCardAdded,
  onOtpVerified,
  invoiceNum,
}) {
  // ── View state ──────────────────────────────────────────────────────────────
  const [cardDetails, setCardDetails] = useState([]);
  const [getCard, setGetCard] = useState(false);
  const [addCard, setAddCard] = useState(false);

  // ── Payment OTP state ────────────────────────────────────────────────────────
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [paymentData, setPaymentData] = useState(null);

  // ── Edit card OTP state ──────────────────────────────────────────────────────
  const [showEditOtpPopup, setShowEditOtpPopup] = useState(false);
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [verifiedCardData, setVerifiedCardData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const posthog = usePostHog();

  // ── Get Card form state ──────────────────────────────────────────────────────
  const [getCardDetails, setGetCardDetails] = useState({ email: "" });
  const [getCardErrors, setGetCardErrors] = useState({ email: "" });

  // ── Add Card form state ──────────────────────────────────────────────────────
  const [addCardData, setAddCardData] = useState({
    cardHolderName: "",
    cardNumber: "",
    expiry: "",
    cvc: "",
    address: "",
    zipCode: "",
    invoiceNumber: "",
    amount: "",
    notes: "",
  });
  const [addCardErrors, setAddCardErrors] = useState({
    cardHolderName: "",
    cardNumber: "",
    expiry: "",
    cvc: "",
    address: "",
    zipCode: "",
    invoiceNumber: "",
    amount: "",
    notes: "",
  });

  // ── API hooks ────────────────────────────────────────────────────────────────
  const { postData: fetchCards } = usePostRequest(
    API_ENDPOINTS.GET_CUSTOMER_CARD,
  );
  const { postData: sendPaymentOtp } = usePostRequest(
    API_ENDPOINTS.PAYMENT_OTP,
  );
  const { isLoading: isLoadingGetCard, postData: postGetCard } = usePostRequest(
    API_ENDPOINTS.VERIFY_CUSTOMER_EMAIL,
  );
  const { isLoading: isLoadingAddCard, postData: postAddCard } = usePostRequest(
    API_ENDPOINTS.CREATE_CARD_INFO,
  );
  const { postData: VerifyCustomerOtp, data: Verified } = usePostRequest(
    API_ENDPOINTS.SEND_OTP_CARDS,
  );

  const user = useSelector((state) => state.auth.user);
  const canEditCards = user?.permissions?.manage_cards?.includes("write");

  // ── Fetch cards on open ──────────────────────────────────────────────────────
  useEffect(() => {
    if (show) {
      fetchCards(
        { email: emailId, other_id: orderId, type: "ORDER" },
        (res) => setCardDetails(res?.data || []),
        // (err) =>
        //   toast.error(
        //     err?.message ||
        //       "No valid card details found. Please add card details first.",
        //   ),
      );
      setGetCardDetails({ email: emailId || "" });
      // Pre-populate disabled fields from props so submit validation passes
      setAddCardData((prev) => ({
        ...prev,
        invoiceNumber: orderId || prev.invoiceNumber,
        amount: paymentAmount || prev.amount,
      }));
    } else {
      setCardDetails([]);
    }
  }, [show]);

  const refreshCards = () => {
    fetchCards(
      { email: emailId, other_id: orderId, type: "ORDER" },
      (res) => setCardDetails(res?.data || []),
      (err) => toast.error(err?.message || "Failed to refresh card details."),
    );
  };

  // ── Validation helpers ───────────────────────────────────────────────────────
  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const validateCardHolderName = (value) => /^[A-Za-z\s]+$/.test(value);
  const validateCardNumber = (value) => /^[0-9]{15,16}$/.test(value);
  const validateExpiry = (value) => {
    if (!/^(0[1-9]|1[0-2])\/\d{2}$/.test(value)) return false;
    const month = parseInt(value.slice(0, 2), 10);
    return month >= 1 && month <= 12;
  };
  const validateCVC = (value) => /^\d{3,4}$/.test(value);
  const validateZipCode = (value) => /^\d{5,9}$/.test(value);
  const validateAmount = (value) => !isNaN(value) && parseFloat(value) > 0;

  // ── Payment OTP handlers ─────────────────────────────────────────────────────
  const handleOtp = (cardInfo) => {
    setPaymentData(cardInfo);
    sendPaymentOtp(
      { id: cardInfo?.id, type: "order_payment" },
      (res) => {
        toast.success(res?.message || "OTP sent successfully");
        setShowOtpPopup(true);
        onClose();
      },
      (err) => toast.error(err?.message || "Failed to initiate payment OTP"),
    );
  };

  const handleOtpVerified = (response) => {
    if (onOtpVerified) onOtpVerified(response);
  };

  // ── Edit card OTP handlers ───────────────────────────────────────────────────
  const openEditModal = (id) => {
    const handleSendOtp = () => {
      VerifyCustomerOtp({ id }, onSuccessVerify, onErrorVerify);
      setIsModalOpen((prev) => ({ ...prev, show: false }));
      onClose();
    };

    setIsModalOpen({
      show: true,
      action: "success",
      message:
        "Are you sure you want to view/edit customer's card details? An OTP will be sent for verification if you proceed.",
      onConfirm: handleSendOtp,
      title: "Edit Customer Card Details",
      icon: <IconCreditCard />,
      type: "info",
    });
  };

  const onSuccessVerify = (res) => {
    toast.success(res?.message);
    setShowEditOtpPopup(true);
  };

  const onErrorVerify = (err) => {
    toast.error(err?.message || "Failed to send OTP");
  };

  const handleOtpVerifiedEdit = (verifiedResponse) => {
    setVerifiedCardData(verifiedResponse);
    setShowEditOtpPopup(false);
    setShowCardDetails(true);
  };

  // ── Get Card handlers ────────────────────────────────────────────────────────
  const handleGetCardChange = (e) => {
    const { name, value } = e.target;
    let error = "";
    if (value.trim() === "") {
      error = `${name} is required`;
    } else if (name === "email" && !validateEmail(value)) {
      error = "Invalid email address";
    }
    setGetCardDetails((prev) => ({ ...prev, [name]: value }));
    setGetCardErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleGetCardSubmit = (e) => {
    e.preventDefault();
    if (getCardDetails.email.trim() === "" || getCardErrors.email !== "") {
      toast.error("Please correct the email before submitting");
      return;
    }
    postGetCard(
      { other_id: orderId, email: getCardDetails.email },
      (res) => {
        toast.success(res?.message || "Card link sent successfully");
        refreshCards();
        if (onCardAdded) onCardAdded();
        resetForms();
      },
      (err) => toast.error(err?.message || "Failed to generate link for card"),
    );
  };

  // ── Add Card handlers ────────────────────────────────────────────────────────
  const handleAddCardChange = (e) => {
    const { name, value } = e.target;
    let validationError = "";
    let formattedValue = value;

    switch (name) {
      case "cardNumber": {
        const digits = value.replace(/\D/g, "").slice(0, 16);
        formattedValue = digits.replace(/(.{4})(?=.)/g, "$1 ");
        if (digits && !validateCardNumber(digits))
          validationError = "Card number must be 15 or 16 digits";
        else if (digits.trim() === "")
          validationError = "Card number is required";
        break;
      }

      case "expiry": {
        const digits = value.replace(/\D/g, "").slice(0, 4);
        formattedValue =
          digits.length >= 3
            ? `${digits.slice(0, 2)}/${digits.slice(2)}`
            : digits;
        if (formattedValue.trim() === "")
          validationError = "Expiry is required";
        else if (!validateExpiry(formattedValue))
          validationError =
            "Expiry must be in MM/YY format with a valid month (01–12)";
        break;
      }

      case "cvc": {
        formattedValue = value.replace(/\D/g, "").slice(0, 4);
        if (formattedValue && !validateCVC(formattedValue))
          validationError = "CVC must be 3 or 4 digits";
        break;
      }

      case "zipCode": {
        formattedValue = value.replace(/\D/g, "").slice(0, 9);
        if (formattedValue.trim() === "")
          validationError = "ZIP Code is required";
        else if (!validateZipCode(formattedValue))
          validationError = "ZIP code must be 5–9 digits";
        break;
      }

      case "invoiceNumber": {
        if (value.trim() === "") validationError = "Invoice number is required";
        break;
      }

      case "amount": {
        if (value.trim() === "") validationError = "Amount is required";
        else if (!validateAmount(value))
          validationError = "Amount must be a positive number";
        break;
      }

      case "cardHolderName": {
        if (value.trim() === "")
          validationError = "Cardholder name is required";
        else if (!validateCardHolderName(value))
          validationError =
            "Cardholder name can only contain letters and spaces";
        break;
      }

      // address and notes: no validation required
      default:
        break;
    }

    setAddCardData((prev) => ({ ...prev, [name]: formattedValue }));
    setAddCardErrors((prev) => ({ ...prev, [name]: validationError }));
  };

  const handleAddCardSubmit = (e) => {
    e.preventDefault();

    const requiredFields = {
      cardHolderName: "Cardholder name is required",
      cardNumber: "Card number is required",
      expiry: "Expiry is required",
      zipCode: "ZIP Code is required",
      invoiceNumber: "Invoice number is required",
      amount: "Amount is required",
    };

    // Trigger validation on all required fields
    const newErrors = { ...addCardErrors };
    let hasError = false;

    Object.entries(requiredFields).forEach(([field, msg]) => {
      if (!addCardData[field] || addCardData[field].trim() === "") {
        newErrors[field] = msg;
        hasError = true;
      }
    });

    setAddCardErrors(newErrors);

    const existingErrors = Object.values(newErrors).some((err) => err !== "");
    if (hasError || existingErrors) {
      toast.error("Please fix all errors before submitting");
      return;
    }

    postAddCard(
      {
        auto_id: orderId,
        info_number: addCardData.cardNumber.replace(/\s+/g, ""),
        info_expiry: addCardData.expiry.replace("/", ""),
        info_name: addCardData.cardHolderName,
        cvc_code: addCardData.cvc || null,
        address: addCardData.address || null,
        zip_code: addCardData.zipCode,
        invoice_number: addCardData.invoiceNumber,
        amount: addCardData.amount,
        note: addCardData.notes || null,
        type: "order",
      },
      (res) => {
        toast.success(res?.message || "Card added successfully");
        posthog.capture("payment_details_added", {
          created_by: user?.email,
        });
        refreshCards();
        if (onCardAdded) onCardAdded();
        resetForms();
      },
      (err) => toast.error(err?.message || "Failed to add card"),
    );
  };

  // ── Reset / cancel ───────────────────────────────────────────────────────────
  const resetForms = () => {
    setGetCard(false);
    setAddCard(false);
    setGetCardDetails({ email: emailId || "" });
    setGetCardErrors({ email: "" });
    setAddCardData({
      cardHolderName: "",
      cardNumber: "",
      expiry: "",
      cvc: "",
      address: "",
      zipCode: "",
      invoiceNumber: orderId || "",
      amount: paymentAmount || "",
      notes: "",
    });
    setAddCardErrors({
      cardHolderName: "",
      cardNumber: "",
      expiry: "",
      cvc: "",
      address: "",
      zipCode: "",
      invoiceNumber: "",
      amount: "",
      notes: "",
    });
  };

  const handleClose = () => {
    resetForms();
    onClose();
  };

  useEffect(() => {
    if (show) {
      posthog.stopSessionRecording();
    } else {
      posthog.startSessionRecording();
    }
  }, [show]);

  return (
    <>
      {/* Edit Card - after OTP verified */}
      {showCardDetails && (
        <CustomerCardEdit
          show={showCardDetails}
          onClose={() => setShowCardDetails(false)}
          formData={verifiedCardData}
        />
      )}

      {/* Edit confirmation modal */}
      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => setIsModalOpen((prev) => ({ ...prev, show: false }))}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />

      {/* Edit OTP verification popup */}
      {showEditOtpPopup && (
        <OtpVerifyPopup
          show={showEditOtpPopup}
          onClose={() => setShowEditOtpPopup(false)}
          formData={Verified}
          onVerified={handleOtpVerifiedEdit}
        />
      )}

      {/* Payment OTP verification popup */}
      {showOtpPopup && (
        <OtpVerficationViewDetail
          show={showOtpPopup}
          onClose={() => setShowOtpPopup(false)}
          formData={paymentData}
          paymentAmountSales={paymentAmount}
          opportunityId={orderId}
          onVerified={(response) => {
            handleOtpVerified(response);
            setShowOtpPopup(false);
          }}
        />
      )}

      <Modal show={show} onHide={handleClose} size="xl">
        <Modal.Header
          className="gap-2 justify-content-between pe-5"
          closeButton
        >
          <div className="d-flex align-items-center gap-2">
            <span className="avatar bg-indigo-lt rounded-circle">
              <IconCreditCard />
            </span>
            <Modal.Title>Card Details</Modal.Title>
          </div>
          <div className="d-flex gap-2">
            <span
              className="add_new_card bg-indigo"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setAddCard(!addCard);
                setGetCard(false);
              }}
            >
              {addCard ? "Hide" : "Add Card"}
            </span>
            <span
              className="add_new_card bg-indigo"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setGetCard(!getCard);
                setAddCard(false);
              }}
            >
              {getCard ? "Hide" : "Get Card"}
            </span>
          </div>
        </Modal.Header>

        <Modal.Body>
          {/* ── Card Listing Table ─────────────────────────────────────────── */}
          <div className="table-responsive mail_wrapper p-0 border-0 mb-3 box-shadow-none">
            <Table className="table-bordered card-table">
              <thead>
                <tr>
                  <th>CARDHOLDER NAME</th>
                  <th>CARD NUMBER</th>
                  <th>CARD EXPIRY</th>
                  <th>INVOICE NUMBER</th>
                  <th>CREATED DATE</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {cardDetails.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No card details found.
                    </td>
                  </tr>
                ) : (
                  cardDetails.map((card) => (
                    <React.Fragment key={card.id}>
                      <tr>
                        <td>{card.info_name}</td>
                        <td>{"**** **** **** " + card.info_number}</td>
                        <td>{card.info_expiry}</td>
                        <td>{card.invoice_number || "N/A"}</td>
                        <td>{moment(card.created_at).format("MM/DD/YYYY")}</td>
                        <td className="d-flex gap-2">
                          {!transactionId && (
                            <Button
                              className="w-auto"
                              style={{ minWidth: "auto" }}
                              onClick={() => handleOtp(card)}
                            >
                              Pay
                            </Button>
                          )}
                          <Button
                            className="w-auto"
                            style={{ minWidth: "auto" }}
                            onClick={() => openEditModal(card?.id)}
                            disabled={!canEditCards}
                          >
                            View/Edit
                          </Button>
                        </td>
                      </tr>
                      <tr key={`note-${card.id}`}>
                        <td colSpan="6" className="text-end">
                          Notes: {card.note || "N/A"}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))
                )}
              </tbody>
            </Table>
          </div>

          {/* ── Get Card Section ───────────────────────────────────────────── */}
          {getCard && (
            <Card className="add_credit_card mb-3 mt-3">
              <Card.Header className="card_header">GET NEW CARD</Card.Header>
              <Card.Body>
                <Form onSubmit={handleGetCardSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label className="required">EMAIL</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={getCardDetails.email}
                      onChange={handleGetCardChange}
                      placeholder="Enter your email address"
                    />
                    {getCardErrors.email && (
                      <div className="text-danger">{getCardErrors.email}</div>
                    )}
                  </Form.Group>
                  <div className="d-flex justify-content-center gap-2">
                    <Button
                      type="submit"
                      variant="primary"
                      disabled={
                        isLoadingGetCard ||
                        getCardDetails.email.trim() === "" ||
                        !!getCardErrors.email
                      }
                    >
                      {isLoadingGetCard ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Get Card"
                      )}
                    </Button>
                    <Button
                      type="button"
                      variant="outline-secondary"
                      onClick={resetForms}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          )}

          {/* ── Add Card Section ───────────────────────────────────────────── */}
          {addCard && (
            <Card className="add_credit_card mb-3 mt-3">
              <Card.Header className="card_header">ADD NEW CARD</Card.Header>
              <Card.Body>
                <Form onSubmit={handleAddCardSubmit}>
                  <Row>
                    {/* Cardholder Name */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="required">
                          CARDHOLDER NAME
                        </Form.Label>
                        <Form.Control
                          name="cardHolderName"
                          value={addCardData.cardHolderName}
                          onChange={handleAddCardChange}
                          placeholder="Enter Cardholder Name"
                          isInvalid={!!addCardErrors.cardHolderName}
                        />
                        {addCardErrors.cardHolderName && (
                          <div className="text-danger small">
                            {addCardErrors.cardHolderName}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Card Number */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="required">
                          CARD NUMBER
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <IconBrandVisa stroke={1} />
                          </InputGroup.Text>
                          <Form.Control
                            name="cardNumber"
                            value={addCardData.cardNumber}
                            onChange={handleAddCardChange}
                            type="text"
                            placeholder="**** **** **** ****"
                            isInvalid={!!addCardErrors.cardNumber}
                          />
                        </InputGroup>
                        {addCardErrors.cardNumber && (
                          <div className="text-danger small">
                            {addCardErrors.cardNumber}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Expiry */}
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="required">EXPIRY</Form.Label>
                        <Form.Control
                          name="expiry"
                          value={addCardData.expiry}
                          onChange={handleAddCardChange}
                          type="text"
                          placeholder="MM/YY"
                          maxLength={5}
                          isInvalid={!!addCardErrors.expiry}
                        />
                        {addCardErrors.expiry && (
                          <div className="text-danger small">
                            {addCardErrors.expiry}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* CVC */}
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>CVC CODE</Form.Label>
                        <Form.Control
                          name="cvc"
                          value={addCardData.cvc}
                          onChange={handleAddCardChange}
                          type="password"
                          maxLength={4}
                          placeholder="123"
                          isInvalid={!!addCardErrors.cvc}
                        />
                        {addCardErrors.cvc && (
                          <div className="text-danger small">
                            {addCardErrors.cvc}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ZIP Code */}
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="required">ZIP CODE</Form.Label>
                        <Form.Control
                          name="zipCode"
                          value={addCardData.zipCode}
                          onChange={handleAddCardChange}
                          placeholder="90210"
                          isInvalid={!!addCardErrors.zipCode}
                        />
                        {addCardErrors.zipCode && (
                          <div className="text-danger small">
                            {addCardErrors.zipCode}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Address */}
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>ADDRESS</Form.Label>
                        <Form.Control
                          name="address"
                          value={addCardData.address}
                          onChange={handleAddCardChange}
                          placeholder="Enter Address"
                        />
                      </Form.Group>
                    </Col>

                    {/* Invoice Number */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="required">
                          INVOICE NUMBER
                        </Form.Label>
                        <Form.Control
                          name="invoiceNumber"
                          value={addCardData.invoiceNumber}
                          onChange={handleAddCardChange}
                          disabled={true}
                          type="text"
                          placeholder="Enter Invoice Number"
                          isInvalid={!!addCardErrors.invoiceNumber}
                        />
                        {addCardErrors.invoiceNumber && (
                          <div className="text-danger small">
                            {addCardErrors.invoiceNumber}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Amount */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="required">AMOUNT</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <IconCurrencyDollar stroke={2} />
                          </InputGroup.Text>
                          <Form.Control
                            name="amount"
                            value={addCardData.amount}
                            onChange={handleAddCardChange}
                            disabled={true}
                            type="number"
                            step="0.01"
                            min="0"
                            placeholder="Enter Amount"
                            isInvalid={!!addCardErrors.amount}
                          />
                        </InputGroup>
                        {addCardErrors.amount && (
                          <div className="text-danger small">
                            {addCardErrors.amount}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Notes */}
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>ADDITIONAL NOTES</Form.Label>
                        <Form.Control
                          name="notes"
                          value={addCardData.notes}
                          onChange={handleAddCardChange}
                          placeholder="Enter notes"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <div className="d-flex justify-content-center gap-2">
                    <Button
                      type="submit"
                      variant="warning"
                      disabled={
                        isLoadingAddCard ||
                        Object.values(addCardErrors).some(
                          (err) => err !== "",
                        ) ||
                        addCardData.cardHolderName.trim() === "" ||
                        addCardData.cardNumber.trim() === "" ||
                        addCardData.expiry.trim() === "" ||
                        addCardData.zipCode.trim() === "" ||
                        addCardData.invoiceNumber.trim() === "" ||
                        addCardData.amount.toString().trim() === ""
                      }
                    >
                      {isLoadingAddCard ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                    <Button
                      type="button"
                      variant="outline-secondary"
                      onClick={resetForms}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CardManagement;
